module.exports = __webpack_public_path__ + "img/heavenly backup dancers.d2c1fe03.png";